import * as React from "react";
import { PureComponent } from "react";
import DropDownMenu from "material-ui/DropDownMenu";
import MenuItem from "material-ui/MenuItem";
import { List } from "immutable";
import { DATATEST } from "constants/integration";

interface IProps {
    activeCurrency: string;
    availableCurrencies: List<string>;
    onSetCurrency: (code: string) => void;
}

export default class CurrencySelect extends PureComponent<IProps, {}> {
    render() {
        const { activeCurrency, availableCurrencies } = this.props;
        if (availableCurrencies.size <= 1) {
            return null;
        }
        return (
            <DropDownMenu
                data-test={DATATEST.GALLERY.CURRENCY_SELECTOR}
                value={activeCurrency}
                onChange={this.handleChange}
            >
                {availableCurrencies.map((code) => (
                    <MenuItem data-test={`currency-menuitem-${code}`} key={code} value={code} primaryText={code} />
                ))}
            </DropDownMenu>
        );
    }

    private handleChange = (event: any, index: number, value: string) => {
        this.props.onSetCurrency(value);
    };
}
